import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface ClientTermsStatus {
  hasAccepted: boolean;
  acceptedAt: string | null;
  currentTermsUrl: string | null;
  needsUpdate: boolean;
  signatureData: string | null;
}

export const useClientTermsStatus = (clientId: string | undefined) => {
  return useQuery({
    queryKey: ['client-terms-status', clientId],
    queryFn: async () => {
      if (!clientId) throw new Error('Client ID is required');

      const { data, error } = await supabase
        .rpc('get_client_terms_status', { p_client_id: clientId });

      if (error) throw error;

      if (!data || data.length === 0) {
        return {
          hasAccepted: false,
          acceptedAt: null,
          currentTermsUrl: null,
          needsUpdate: false,
          signatureData: null
        } as ClientTermsStatus;
      }

      const result = data[0];
      return {
        hasAccepted: result.has_accepted,
        acceptedAt: result.accepted_at,
        currentTermsUrl: result.current_terms_url,
        needsUpdate: result.needs_update,
        signatureData: result.signature_data
      } as ClientTermsStatus;
    },
    enabled: !!clientId,
    staleTime: 0, // Allow immediate refresh after invalidation
  });
};